var React = require('react');

function CheckMark (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","d":"M15.414 0l1.414 1.414L5.414 12.828 0 7.414 1.414 6l4 3.999z"}));
}

CheckMark.defaultProps = {"width":"17","height":"13"};

module.exports = CheckMark;

CheckMark.default = CheckMark;
